export const environment = {
    production: false,
    apiEndpoint: 'https://cepprodtest.controlexpert.expert/api/EasyClaim/'
    //apiEndpoint: 'http://cep.controlexpert.expert/api/EasyClaim/' 
};
